import { useState } from 'react';
import type { ReconciliationRunRowsQuery } from '@shared/api/contracts';
import { useApiServices } from '@shared/lib/use-api-services';
import { csvFilenameStamp, downloadBlob, filenameFromDisposition } from '@shared/lib/download-blob';

export function useReconciliationRunExport(runId: string | null, filters: ReconciliationRunRowsQuery = {}) {
  const services = useApiServices();
  const [isExporting, setIsExporting] = useState(false);

  const exportCsv = async () => {
    if (!runId) throw new Error('run id required');
    setIsExporting(true);
    try {
      const { blob, headers } = await services.reconciliation.exportRunCsv(runId, filters);
      const filename =
        filenameFromDisposition(headers.get('content-disposition')) ??
        `reconciliation-${csvFilenameStamp()}.csv`;
      downloadBlob(blob, filename);
    } finally {
      setIsExporting(false);
    }
  };

  return { exportCsv, isExporting };
}
